var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocReprovado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "doc-reprovado",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.946,
    height: 35.17,
    viewBox: "0 0 34.946 35.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14476",
    "data-name": "Grupo 14476",
    transform: "translate(-919.054 -309.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search-alt",
    d: "M20.811,8.062a1.344,1.344,0,0,1,0,2.687H10.062a1.344,1.344,0,0,1,0-2.687ZM16.78,29.56H8.718a4.031,4.031,0,0,1-4.031-4.031V6.718A4.031,4.031,0,0,1,8.718,2.687H24.842a1.344,1.344,0,0,1,1.344,1.344V14.78a1.344,1.344,0,1,0,2.687,0V4.031A4.031,4.031,0,0,0,24.842,0H8.718A6.726,6.726,0,0,0,2,6.718V25.529a6.726,6.726,0,0,0,6.718,6.718H16.78a1.344,1.344,0,0,0,0-2.687Z",
    transform: "translate(917.054 309.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search-alt-2",
    "data-name": "search-alt",
    d: "M20,7.091a1.344,1.344,0,0,1,0,2.687H9.253a1.344,1.344,0,0,1,0-2.687Z",
    transform: "translate(917.863 315.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search-alt-3",
    "data-name": "search-alt",
    d: "M20,7.091a1.344,1.344,0,0,1,0,2.687H9.253a1.344,1.344,0,0,1,0-2.687Z",
    transform: "translate(917.863 319.896)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "remove",
    transform: "translate(18.946 19.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,0",
    fill: "#ff460c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M161.559,160.616a.667.667,0,1,1-.943.943l-2-2-2,2a.667.667,0,0,1-.943-.943l2-2-2-2a.667.667,0,0,1,.943-.943l2,2,2-2a.667.667,0,0,1,.943.943l-2,2Zm0,0",
    transform: "translate(-150.613 -150.613)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocReprovado);
export default __webpack_public_path__ + "static/media/doc-reprovado.270f79d6ecd8eb4fe87d7f3c1572ebc1.svg";
export { ForwardRef as ReactComponent };